import { useParams } from 'react-router-dom';
import BaseOrientationCheckout from './BaseOrientationCheckout';

const ComputingOrientationCheckout = () => {
    const { uuid } = useParams<{ uuid: string }>();
    return (
        <BaseOrientationCheckout
            // eventUuid={uuid || ''} // ------------------------------------------------------------------ Temporary put back after
            primaryColor="#00285a" // Computing blue
            secondaryColor="#c60601" // Computing red
            gradientFrom="from-[#00285a]"
            gradientTo="to-[#c60601]"
            logoUrl="/branding/orientation/Logo-Zoomed.png"
            customDateText="September 6 - 13, 2026"
            customLinks={[
                // {
                //     alias: "Computing Resources",
                //     url: "https://www.mcmaster.ca/computing/resources"
                // },
                // {
                //     alias: "Program Guide",
                //     url: "https://www.mcmaster.ca/computing/program-guide"
                // },
                // {
                //     alias: "Student Services",
                //     url: "https://www.mcmaster.ca/computing/student-services"
                // }
            ]}
            customStyles={{
                headerBg: 'bg-[#f8c700]/20', // soft yellow
                cardBg: 'bg-white',
                buttonGradient: 'linear-gradient(to right, #c60601, #f8c700)',
                buttonHoverGradient: 'linear-gradient(to right, #c60601, #ffe066)',
                tagBg: 'bg-[#00285a] text-white', // blue tags
            }}
            ticketsBadgeClass="bg-[#f8c700] text-[#00285a]"
            eventUuid='1d59473c-fbbb-406f-9d70-534bd25ee8ab' // ---------------------------------------------------------------------------- TEMPORARY
            hidePhoneNumber={true}
            hideTicketsAvailable={true}
            photos={[
                "/branding/orientation/computing-photos/comport_1.JPG",
                "/branding/orientation/computing-photos/comport_2.JPG",
                "/branding/orientation/computing-photos/comport_3.JPG",
                "/branding/orientation/computing-photos/comport_4.jpg",
                "/branding/orientation/computing-photos/comport_5.jpg",
                "/branding/orientation/computing-photos/comport_6.JPG"
            ]}
        />
    );
};

export default ComputingOrientationCheckout; 